import useTokenSuperpositionsBalances from "@/hooks/api/useTokenSuperpositionsBalances";

export default function useMutateSuperpositionBalances() {
  const { mutate, isLoading, isError } = useTokenSuperpositionsBalances();

  return {
    isLoading,
    isError,
    mutate: () => {
      mutate()
        .then(data => {
          console.log("[DEBUG] useMutateSuperpositionBalances response", data);
        })
        .catch(error => {
          console.error("[DEBUG] useMutateSuperpositionBalances error", error);
        });
    },
  };
}
